import $ from 'jquery';

function calcImageSize(defaultConfig) {

  const DEFAULT_DIV_WIDTH = defaultConfig.fixedImageDivWidth + defaultConfig.imageDivMargin;

  function calcImgSizeByRatio(imagesInLine, state, lineState, forEachCalc) {
    const accImageWidthWithoutFixed = lineState.accImageWidth - DEFAULT_DIV_WIDTH * lineState.widthFixedCount;
    const calcState = {
      visibleLineCount: 1,
      accDivWidth: 0,
      calcDivHeight: 0,
      calcWidth: 1,
      widthRatio: 0
    };

    $.each(imagesInLine, (idx, data) => {
      calcState.calcWidth = getCalcWidth(data, accImageWidthWithoutFixed, lineState, state.isSingleLine);
      calcState.widthRatio = getWidthRatioByCalcWidth(calcState.calcWidth, data);
      setCalcDivHeightState(calcState, lineState);
      forEachCalc(calcState, data);

      data.lineCount = state.lineCount;
    });
  }


  function setCalcDivHeightState(calcState, lineState) {
    if (calcState.calcDivHeight > 0) {
      return;
    }
    const fixedHeight = defaultConfig.fixedImageDivHeight;
    const maxImgHeight = lineState.maxImageHeight;
    const isShorterThanDefault = maxImgHeight < fixedHeight;
    calcState.calcDivHeight = isShorterThanDefault ? fixedHeight : Math.round(maxImgHeight - (maxImgHeight * calcState.widthRatio));
    // calcState.calcDivHeight += (calcState.calcDivHeight * defaultConfig.cropMagnification);
  }

  return calcImgSizeByRatio;
}

function getWidthRatioByCalcWidth(calcWidth, data) {
  const ratio = calcWidth / data.w * 100;
  return Math.ceil(ratio) * 0.01;
}


function getCalcWidth(data, accImageWidthWithoutFixed, lineState, isSingleLine) {
  let calcWidth = 1;
  // 1. 개별 math_w 를 구해서, w_per를 구한다.
  // image_add_w_without_fixed이 0인 경우는 전부다 fixed type
  if (accImageWidthWithoutFixed > 0) {
    calcWidth = lineState.gap * data.w / accImageWidthWithoutFixed;
  }
  // 표시될 이미지 라인이 1개 밖에 안되는 경우, 박스 사이즈 계산이 이미지보다 커지지 않도록 보정한다.
  if (isSingleLine && calcWidth < 0) {
    calcWidth = 1;
  }
  return calcWidth;
}

export default calcImageSize;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/image_calculator/calc_image_size.js
 **/